<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('messages')"
      :columns="columns"
      :column_search="false"
      :extra_buttons="extra_buttons"
      :extra_data="{ campaign_uuid: campaign_uuid }"
      resource_url="/emarketing/message/datatables"
    ></generic-table>
    <message-modal ref="message_modal" @success="refresh" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
  api_host,
} from "@/utils";
import MessageModal from "./message_modal/Index.vue";

export default {
  name: "MessageDatatable",
  components: { GenericTable, MessageModal },
  data() {
    let v = this;
    return {
      campaign_uuid: "",
      api_host,
      extra_buttons: [
        // {
        //   // text: v.$t("add"),
        //   tooltip: v.$t("add"),
        //   text: "",
        //   icon: "fa fa-plus",
        //   class: "is-secondary is-rounded",
        //   click: this.create,
        // },
      ],
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("send date"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.outbox_message.send_date);
          },
        },
        {
          title: v.$t("to"),
          data: (row) => {
            return row.outbox_message.to || "";
          },
        },
        {
          title: v.$t("status"),
          data: (row) => {
            return row.outbox_message.status_code || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.message_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete message?"),
                    v,
                    () => {
                      del("/emarketing/message", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.region_modal.show_modal(v.subarea_uuid);
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    init(campaign_uuid) {
      let v = this;
      v.campaign_uuid = campaign_uuid;
      try {
        v.$refs.datatable.destroy();
      } catch (error) {
        error_message(error);
      }
      setTimeout(() => {
        v.refresh();
      }, 100);
    },
  },
  mounted() {},
};
</script>

<style></style>
